export const SESSION_STORAGE_KEYS = {
  LAST_ACTIVE_GROUP_BUSINESS_NAME: 'LAST_ACTIVE_GROUP_BUSINESS_NAME',
  LAST_ACTIVE_GROUP_ID: 'LAST_ACTIVE_GROUP_ID',
  LAST_ACTIVE_GROUP_MEMBER_ID: 'LAST_ACTIVE_GROUP_MEMBER_ID',
  SHOW_LAST_ACTIVE_USER_GROUP_MODAL: 'SHOW_LAST_ACTIVE_USER_GROUP_MODAL',
};

export const lastActiveGroupSessionStorage = {
  closeModal: () => {
    sessionStorage.removeItem(
      SESSION_STORAGE_KEYS.LAST_ACTIVE_GROUP_BUSINESS_NAME,
    );
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.LAST_ACTIVE_GROUP_ID);
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.LAST_ACTIVE_GROUP_MEMBER_ID);
    sessionStorage.removeItem(
      SESSION_STORAGE_KEYS.SHOW_LAST_ACTIVE_USER_GROUP_MODAL,
    );
  },
  setState: ({
    lastActiveGroupBusinessName,
    lastActiveGroupId,
    lastActiveGroupMemberId,
    showModal,
  }) => {
    sessionStorage.setItem(
      SESSION_STORAGE_KEYS.LAST_ACTIVE_GROUP_BUSINESS_NAME,
      lastActiveGroupBusinessName,
    );
    sessionStorage.setItem(
      SESSION_STORAGE_KEYS.LAST_ACTIVE_GROUP_ID,
      lastActiveGroupId,
    );
    sessionStorage.setItem(
      SESSION_STORAGE_KEYS.LAST_ACTIVE_GROUP_MEMBER_ID,
      lastActiveGroupMemberId,
    );
    sessionStorage.setItem(
      SESSION_STORAGE_KEYS.SHOW_LAST_ACTIVE_USER_GROUP_MODAL,
      showModal,
    );
  },
};

export const getLastActiveGroupId: number | null = () => {
  const lastActiveGroupId = sessionStorage.getItem(
    SESSION_STORAGE_KEYS.LAST_ACTIVE_GROUP_ID,
  );
  if (lastActiveGroupId === 'null' || lastActiveGroupId === null) {
    return null;
  }
  return Number(lastActiveGroupId);
};

export const getLastActiveGroupMemberId: number | null = () => {
  const lastActiveGroupMemberId = sessionStorage.getItem(
    SESSION_STORAGE_KEYS.LAST_ACTIVE_GROUP_MEMBER_ID,
  );
  if (lastActiveGroupMemberId === 'null' || lastActiveGroupMemberId === null) {
    return null;
  }
  return Number(lastActiveGroupMemberId);
};

export const getLastActiveGroupBusinessName: string | null = () => {
  const lastActiveGroupBusinessName = sessionStorage.getItem(
    SESSION_STORAGE_KEYS.LAST_ACTIVE_GROUP_BUSINESS_NAME,
  );
  if (lastActiveGroupBusinessName === 'null') {
    return null;
  }
  return lastActiveGroupBusinessName;
};

export const getIsShowingModal: boolean | null = () => {
  const isShowingModal = sessionStorage.getItem(
    SESSION_STORAGE_KEYS.SHOW_LAST_ACTIVE_USER_GROUP_MODAL,
  );
  if (isShowingModal === 'null' || isShowingModal === null) {
    return null;
  } else if (isShowingModal === 'false') {
    return false;
  } else if (isShowingModal === 'true') {
    return true;
  }
};
